
// if (localStorage.getItem('climate')) {
//   setTimeout(() => {
// document.getElementById('dropKlima').classList.add('hide')
//   }, 50)
// }

export default {
    items: [{
            name: 'Forside',
            url: '/newsfeed',
            class: 'darkblue gibson h5 semi-bold capitalletter',
            icon: 'el-icon-house ml1 darkblue'
        },
        // {
        //     name: 'Beskeder',
        //     url: '/Beskeder',
        //     class: 'darkblue gibson h5 mr2 regular',
        //     icon: 'el-icon-star-off mr2 darkblue',
        //     children: [{
        //                 name: 'Inbox',
        //                 class: 'darkblue gibson h5 regular',
        //                 url: '/messages/inbox'
        //             },
        //             {
        //                 name: 'Sendt',
        //                 class: 'darkblue gibson h5 regular',
        //                 url: '/messages/sent'
        //             }
        //         ]
        //         // icon: 'el-icon-star-on text-warning mr-2'
        // },
        {
            name: 'Anbefalinger',
            url: '/anbefalinger',
            class: 'darkblue gibson h5 mr2 regular',
            icon: 'el-icon-star-off mr2 darkblue',
            children: [{
                        name: 'Indhent anbefalinger',
                        class: 'darkblue gibson h5 regular',
                        url: '/indhent-anbefalinger'
                    },
                    {
                        name: 'Læs og besvar',
                        class: 'darkblue gibson h5 regular',
                        url: '/laes-og-besvar-anbefalinger'
                    },
                    {
                        name: 'Anbefaling',
                        class: 'darkblue gibson h5 regular ',
                        url: '/anbefalinger-sammendrag'
                    },
                    {
                        name: 'Sæt anbefalinger på Auto-pilot',
                        class: 'darkblue gibson h5 regular pl1',
                        url: '/auto-anbefalinger'
                    },
                    {
                        name: 'Widgets',
                        class: 'darkblue gibson h5 regular',
                        url: '/widgets'
                    }
                ]
                // icon: 'el-icon-star-on text-warning mr-2'
        },
        {   
            name: 'Mine kunder',
            url: '/alle-moeder',
            class: 'darkblue gibson h5 semi-bold',
            icon: 'el-icon-files mr2 darkblue'
        },
        // {
        //     name: 'Mine kunder Test',
        //     url: '',
        //     class: 'darkblue gibson h5 semi-bold',
        //     icon: 'el-icon-files mr2 darkblue',
        //     children: [
        //         {
        //             name: 'Kunder',
        //             class: 'darkblue gibson h5 regular',
        //             url: '/alle-moeder'
        //         },
        //         {
        //             name: 'Bolig ejer',
        //             class: 'darkblue gibson h5 regular',
        //             url: '/property-owner'
        //         }
        //     ]
        // },
        /* {
            name: 'Kontrakter',
            url: '/contracts',
            class: 'darkblue gibson h5 regular',
            icon: 'el-icon-document mr2 darkblue'
        }, */
        {
            name: 'Dine projekter',
            url: '/',
            class: 'darkblue gibson h5 regular',
            icon: 'el-icon-picture-outline mr2 darkblue',
            children: [{
                    name: 'Opret projekt',
                    url: '/opret-projekt-new',
                    class: 'darkblue gibson h5 regular'
                },
                {
                    name: 'Mine projekter',
                    url: '/status-haandvaerker-new',
                    class: 'darkblue gibson h5 regular'
                },
                // {
                //     name: 'Åbne kundeprojekter',
                //     url: '/customer-projects/approved-projects',
                //     class: 'darkblue gibson h5 regular'
                // },
                {
                    name: 'Vundne kundeprojekter',
                    url: '/customer-projects/project-dashboard',
                    class: 'darkblue gibson h5 regular'
                }
            ]
        },
        {
            name: 'Markedsplads',
            url: '/markedsplads',
            class: 'darkblue gibson h5 semi-bold',
            icon: 'el-icon-money mr2 darkblue',
            children: [
                // {
                // name: 'Privat udbud',
                // url: '/privat-udbud',
                // class: 'darkblue gibson h5 regular'
                // },
                {
                name: 'Offentlig udbud',
                url: '/offentlige-udbud',
                class: 'darkblue gibson h5 regular'
                }
                // {
                // name: 'Opgaveinvitationer',
                // url: '/opgaveinvitationer',
                // class: 'darkblue gibson h5 regular'
                // }
            ]
        },
        {
            name: 'Mester-til-Mester',
            url: '/',
            class: 'darkblue gibson h5 regular',
            icon: 'el-icon-share mr2 darkblue',
            children: [{
                    name: 'Arbejdskraft',
                    url: '/mester-arbejdskraft',
                    class: 'darkblue gibson h5 regular'
                },
                {
                    name: 'Opgaver',
                    url: '/mester-opgaver',
                    class: 'darkblue gibson h5 regular'
                }
            ]
        },
        // {
        //     name: 'Opret tilbud',
        //     url: '/',
        //     class: 'darkblue gibson h5 regular',
        //     icon: 'el-icon-document mr2 darkblue',
        //     children: [{
        //             name: 'Tilbudshistorie',
        //             url: '/tilbud/tilbud-historie',
        //             class: 'darkblue gibson h5 regular'
        //         }
        //         {
        //             name: 'Standard Tilbud',
        //             url: '/tilbud/standardTilbud',
        //             class: 'darkblue gibson h5 regular'
        //         } ,
        //         {
        //             name: 'Hurtigt Tilbud',
        //             url: '/tilbud/hurtigt-tilbud',
        //             class: 'darkblue gibson h5 regular'
        //         },
        //         {
        //             name: 'Upload Tilbud',
        //             url: '/tilbud/upload-tilbud',
        //             class: 'darkblue gibson h5 regular'
        //         }
        //     ]
        // },
        {
            name: 'Tilbudshistorie',
            url: '/tilbud/tilbud-historie',
            class: 'darkblue gibson h5 semi-bold',
            icon: 'el-icon-document mr2 darkblue'
        },
        {
            name: 'Inviter en kollega',
            url: '/inviter-en-kollega',
            class: 'darkblue gibson h5 regular hide',
            icon: 'el-icon-present mr2 darkblue'
        },
        {
            name: 'Gratis hjemmeside',
            url: '/hjemmeside',
            class: 'darkblue gibson h5 semi-bold nav-dropdown-toggle ',
            icon: 'el-icon-monitor mr2 darkblue'
        },
        {
            name: 'Medlemsfordele',
            url: '/medlemsfordele',
            class: 'darkblue gibson h5 regular',
            icon: 'el-icon-present mr2 darkblue'
        },
        {
            name: 'Webshop',
            url: '/',
            class: 'darkblue gibson h5 regular',
            icon: 'el-icon-shopping-cart-2 mr2 darkblue',
            children: [
                // {
                //     name: 'Kategorier',
                //     url: '/webshop/overview',
                //     class: 'darkblue gibson h5 regular'
                // },
                {
                    name: 'Alle produkter',
                    url: '/webshop/products',
                    class: 'darkblue gibson h5 regular'
                }
                // {
                //     name: 'FB Ads',
                //     url: '/webshop/fb-ads',
                //     class: 'darkblue gibson h5 regular'
                // },
                // {
                //     name: 'Google Ads',
                //     url: '/webshop/google-ads',
                //     class: 'darkblue gibson h5 regular'
                // },
                // {
                //     name: 'Boost Profil',
                //     url: '/webshop/boost-profilside',
                //     class: 'darkblue gibson h5 regular'
                // },
                // {
                //     name: 'Boost Projekt',
                //     url: '/webshop/boost-projekt',
                //     class: 'darkblue gibson h5 regular'
                // }
                // {
                //     name: 'Boost Anbefaling',
                //     url: '/webshop/boost-en-anbefaling',
                //     class: 'darkblue gibson h5 regular'
                // }
            ]
        },
        // {
        //     name: 'Klima',
        //     url: '/',
        //     class: 'darkblue gibson h5 regular ',
        //     icon: 'el-icon-money mr2 darkblue',
        //     children: [{
        //         name: 'Klima Plan',
        //         url: '/klima/klima',
        //         class: 'darkblue gibson h5 regular'
        //     }]
        // },
        {
            name: 'Digital pakke',
            url: '/badges',
            class: 'darkblue gibson h5 semi-bold',
            icon: 'el-icon-present mr2 darkblue'
        },
        {
            name: 'Arbejdsseddel',
            url: '/',
            class: 'darkblue gibson h5 regular',
            icon: 'el-icon-share mr2 darkblue',
            children: [{
                name: 'Ny Arbejdsseddel',
                url: '/addendum',
                class: 'darkblue gibson h5 semi-bold',
            },
            {
                name: 'Arbejdsseddeler',
                url: '/worksheet',
                class: 'darkblue gibson h5 semi-bold',
            }]
        },
        // {
        //     name: 'Integrationer',
        //     url: '/ordrestyring',
        //     class: 'darkblue gibson h5 regular',
        //     icon: 'el-icon-connection mr2 darkblue'
        // },
        {
            name: 'Indstillinger',
            url: '/settings',
            icon: 'el-icon-setting mr2 darkblue',
            class: 'darkblue gibson h5 semi-bold'
        },
        {
            name: 'Ofte stillede spørgsmål',
            url: '/faq',
            icon: 'el-icon-question mr2 darkblue',
            class: 'darkblue gibson h5 regular'
        },
        {
            name: 'Log ud',
            url: '/login',
            class: 'darkblue gibson h5 regular pt3',
            icon: 'el-icon-back mr2 darkblue'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/_nav.js